import { Action, createReducer, on } from '@ngrx/store';
import * as CouponsActions from '../actions/coupons.actions';
import { Coupons, CouponsDTO, CouponsFilters } from '../../commons/models/coupons';

export interface CouponState {
  list: CouponsDTO[];
  total: number;
  includes: string[];
  currentPage: number;
  perPage: number;
  order: string;
  direction: string;
  filters: CouponsFilters;
  dialogId: string;
  selectionDialogId: string;
  coupon: CouponsDTO;
  selectedCoupons: Coupons[];
}

const initialState: CouponState = {
  list: [],
  total: 0,
  includes: [],
  currentPage: 1,
  perPage: 25,
  order: null,
  direction: null,
  filters: null,
  dialogId: null,
  selectionDialogId: null,
  coupon: null,
  selectedCoupons: []
};

const couponsReducer = createReducer(
  initialState,

  // Caricamento coupon completato
  on(CouponsActions.loadCouponsCompleted, (state, { coupons, currentPage, total, perPage, order, direction, filters, includes }) => ({
    ...state,
    list: coupons,
    currentPage,
    total,
    perPage,
    order,
    direction,
    filters,
    includes
  })),

  on(CouponsActions.couponDialogOpened, (state, { dialogId }) => ({
    ...state,
    dialogId,
  })),
);

export function reducer(state: CouponState | undefined, action: Action) {
  return couponsReducer(state, action);
}
